var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard"},_vm._l((_vm.messages),function(msg){return _c('TextMessage',{key:msg.id,attrs:{"title":msg.title,"message":msg.message,"color":msg.color,"size":msg.size}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }